declare const __brand: unique symbol;

/**
 * Opaque branded string type.
 *
 * Only values produced by {@link brandedString} carry this brand.
 * This prevents callers from passing raw string literals where a typed
 * constant is expected (e.g. `can('some-value')` is a type error;
 * `can(TenantActions.DELETE)` is not).
 */
export type BrandedString<T extends string = string> = T & {
  readonly [__brand]: typeof __brand;
};

/**
 * Creates a type-safe record of branded string constants.
 *
 * @example
 * export const TenantActions = brandedString({
 *   DELETE: 'tenant-management:tenant.delete',
 * });
 */
export const brandedString = <const T extends Record<string, string>>(
  record: T,
): { [K in keyof T]: BrandedString<T[K]> } => record as never;
